import { BACKEND_URL } from '@/core/config';
import { server } from '../core/server/axios';

export class QrAuthController {
	async createSessionId(isRemote: boolean): Promise<any> {
		return await server.post(`/QrAuth/create?isRemote=${isRemote}`, {}, {
			baseURL: BACKEND_URL
		});
	}
	async isAuthToday(): Promise<any> {
		return await server.get('/QrAuth/isAuthToday', {
			baseURL: BACKEND_URL
		});
	}

	async status({ sessionId }: { sessionId: string }): Promise<{ status: "Pending" | "Scanned" | "Expired" | "Completed" }> { // Pending - ожидание после create , Scanned - после scan, Expired - истек, Completed - завершено после validate
		return await server.get(`/QrAuth/status/${sessionId}`, {
			baseURL: BACKEND_URL
		});
	}

	async getOtp({ lat, lon, sessionId }: { lat: number, lon: number, sessionId: string }): Promise<any> {
		return await server.post('/QrAuth/scan', { lat, lon, sessionId }, {
			baseURL: BACKEND_URL
		});
	}

	async validateOtp({ otp, sessionId }: { otp: string, sessionId: string }): Promise<any> {
		return await server.post('/QrAuth/validate', { otp, sessionId }, {
			baseURL: BACKEND_URL
		});
	}

	async logout(login: string): Promise<any> {
		return await server.get(`/QrAuth/logout/${login}`, {
			baseURL: BACKEND_URL
		});
	}

	async getTimesheetRequests({ depId, from, to }: { depId: string | number, from?: any; to?: any; }): Promise<any> {
		return await server.post(`QrAuth/managerTimeReport`, {
			depId,
			from: from,
			to: to,
		}, {
			baseURL: BACKEND_URL
		});
	}

	async employeeInfoByLogin(login: string): Promise<any> {
		return await server.get(`/Employee/login/${login}`, {
			baseURL: BACKEND_URL
		});
	}
}